import React from 'react'

const EstimateIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="currentColor"
      className={className}
      style={{ display: 'block' }}
    >
      {/* Main House Frame */}
      <path d="M47,62.79H.92V16.53L24,.79,47,16.53V25H40.92V53.83H47Zm-42.12-4H43v-1H36.92V21H43V18.64L24,5.64l-19.06,13Z" />

      {/* Entrance / Lower Detail */}
      <path d="M32.75,62.79H15.2V40.92H32.75Zm-13.55-4h9.55V44.92H19.2Z" />

      {/* Calculator / Grid Frame */}
      <path d="M63.08,57.83H36.92V21H63.08Zm-22.16-4H59.08V25H40.92Z" />
      <path d="M63.08,35.41H36.92V21H63.08Zm-22.16-4H59.08V25H40.92Z" />

      {/* Grid Buttons */}
      <rect x="42.24" y="37.7" width="4" height="3.1" />
      <rect x="48.07" y="37.7" width="4" height="3.1" />
      <rect x="53.76" y="37.7" width="4" height="3.1" />
      <rect x="42.24" y="42.45" width="4" height="3.1" />
      <rect x="48.07" y="42.45" width="4" height="3.1" />
      <rect x="53.76" y="42.45" width="4" height="3.1" />
      <rect x="42.24" y="47.19" width="4" height="3.1" />
      <rect x="48.07" y="47.19" width="4" height="3.1" />
      <rect x="53.76" y="47.19" width="4" height="3.1" />

      {/* Plus Symbol and its Container */}
      <rect x="21.98" y="16.34" width="4" height="13.52" />
      <rect x="17.22" y="21.09" width="13.52" height="4" />
      <path d="M32.74,31.85H15.22V14.34H32.74Zm-13.52-4h9.52V18.34H19.22Z" />
    </svg>
  )
}

export default EstimateIcon
